export default "__VITE_ASSET__Dxj96d64__"